<mat-dialog-content class="dialog-container">
  <div class="row">
    <div class="col-12 text-center">
      <div class="dialog-icon mb-3">
        <img [src]="'assets/media/icons/power-off.png'" alt="Icono">
      </div>
    </div>

    <div class="col-12 text-center">
      <label class="text-danger title-label">
        Su Sesión está a punto de cerrarse, ¿Desea mantenerla?
      </label>
      <p class="code-message">
        Inserte el código: <b>{{generatedCode}}</b>
      </p>
    </div>

    <div class="col-12">
      <form [formGroup]="numericForm">
        <div class="row">
          <div class="col-3 col-sm-3 col-md-3 col-lg-3 text-center">
            <input
              #inputField
              id="input1"
              [ngClass]="{'code-error': codeError}"
              formControlName="input1"
              type="text"
              [mask]="'0'"
              class="digit-input"
              (input)="handleInput(0)"
              (keydown.backspace)="moveToPrev($event,0)"
              tabindex="1"
            />
          </div>

          <div class="col-3 col-sm-3 col-md-3 col-lg-3 text-center">
            <input
              #inputField
              id="input2"
              [ngClass]="{'code-error': codeError}"
              formControlName="input2"
              type="text"
              [mask]="'0'"
              class="digit-input"
              (input)="handleInput(1)"
              (keydown.backspace)="moveToPrev($event,1)"
              tabindex="2"
            />
          </div>

          <div class="col-3 col-sm-3 col-md-3 col-lg-3 text-center">
            <input
              #inputField
              id="input3"
              [ngClass]="{'code-error': codeError}"
              formControlName="input3"
              type="text"
              [mask]="'0'"
              class="digit-input"
              (input)="handleInput(2)"
              (keydown.backspace)="moveToPrev($event,2)"
              tabindex="3"
            />
          </div>

          <div class="col-3 col-sm-3 col-md-3 col-lg-3 text-center">
            <input
              #inputField
              id="input4"
              [ngClass]="{'code-error': codeError}"
              formControlName="input4"
              type="text"
              [mask]="'0'"
              class="digit-input"
              (input)="handleInput(3)"
              (keydown.backspace)="moveToPrev($event,3)"
              tabindex="4"
            />
          </div>
        </div>
      </form>
    </div>


    <div class="col-12 mt-3">
      <div class="d-flex justify-content-between align-items-center">
        <div class="timer">
          {{ remainingTime }} segundos
        </div>

        <button class="btn btn-lg btn-danger" (click)="logout()">
          Cerrar Sesión
        </button>
      </div>
    </div>
  </div>
</mat-dialog-content>
